export default __webpack_public_path__ + "static/IBMPlexSans-ThinItalic-Latin2-a94b274e8380bb7fdf0aaac7052492f6.woff";